export default {
notification: {
  read: "Leído",
  unread: "No leído",
  hide: "Ocultar",
  showAll: "Mostrar todo",
  loading: "Cargando...",
  noMore: "No hay más datos",
  platform: "Plataforma",
  personal: "Personal"
}
};
